import { ElPagination as i } from "element-plus";
import { resolveComponent as o, openBlock as p, createElementBlock as g, createVNode as u, mergeProps as s } from "vue";
import { _ as l } from "../_plugin-vue_export-helper-dad06003.js";
const c = {
  name: "rPagination",
  emits: ["update:currentPage"],
  props: {
    /**
     * 分页单位
     */
    pageSize: {
      type: Number,
      default: 10
    },
    /**
     * 分页总数
     */
    total: {
      type: Number
    },
    /**
     * 当前页
     */
    currentPage: {
      type: Number,
      default: 1
    },
    /**
     * total小于pageSize是否隐藏分页
     */
    hideOnSinglePage: {
      type: Boolean,
      default: !1
    },
    /**
     * 支持两种展示方式default和arrow
     */
    type: {
      type: String,
      default: "default"
    }
  },
  components: {
    Pagination: i
  },
  data() {
    return {
      isPrevPosition: !0
    };
  },
  computed: {
    // arrow的时候只展示箭头，否则同时展示页码，超过10页以上的数据时，展示跳转
    layout() {
      let e = "";
      return this.$attrs.pageSizes && (e = ", sizes"), this.pageSize === 0 ? (this.type === "arrow" ? "prev,next" : "prev, pager, next, ->") + e : this.type === "arrow" ? "prev,next" + e : this.type === "default" && this.total / this.pageSize > 10 ? "prev, pager, next, jumper, ->" + e : "prev, pager, next, ->" + e;
    }
  },
  methods: {
    handleCurrentPageChange(e) {
      this.$emit("update:currentPage", e);
    }
  }
}, d = { class: "r-pagination-wrap" };
function m(e, f, t, P, h, n) {
  const r = o("Pagination", !0);
  return p(), g("div", d, [
    u(r, s(e.$attrs, {
      background: "",
      layout: n.layout,
      "pager-count": 5,
      total: t.total,
      "page-size": t.pageSize,
      "hide-on-single-page": t.hideOnSinglePage,
      ref: "pagination",
      currentPage: t.currentPage,
      "onUpdate:currentPage": n.handleCurrentPageChange
    }), null, 16, ["layout", "total", "page-size", "hide-on-single-page", "currentPage", "onUpdate:currentPage"])
  ]);
}
const a = /* @__PURE__ */ l(c, [["render", m], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/pagination/pagination.vue"]]);
a.install = function(e) {
  e.component(a.name, a);
};
export {
  a as default
};
